import { GlobalSettingsConfig, isCountryClub, ShopConfig } from '@rc-d2c/context-manager';
import { useStore } from 'zustand';

export const useFrequencyList = () => {
  const { country } = useStore(GlobalSettingsConfig.GlobalSettingsStore, (state) => state);
  const { frequencies, deprecatedFrequencies } = useStore(ShopConfig.ShopStore, (state) => state);
  const currentFrequencyList = isCountryClub(country!) ? frequencies : deprecatedFrequencies;

  return { currentFrequencyList };
};

export default useFrequencyList;
